export default __webpack_public_path__ + "static/media/red-check.127cff09.svg";